export default __webpack_public_path__ + "652a49dd7545c142301371df4b83aad5.png";